import firebase from 'firebase/app'
import 'firebase/auth';
import 'firebase/firestore';

const config = {
	projectId: process.env.REACT_APP_PROJECT_ID,
	apiKey: process.env.REACT_APP_API_KEY,
	databaseURL: process.env.REACT_APP_DATABASE_URL,
	authDomain: process.env.REACT_APP_AUTH_DOMAIN,
};

export const fb = firebase.initializeApp(config);
export const db = fb.firestore();

export const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
export const facebookAuthProvider = new firebase.auth.FacebookAuthProvider();
export const twitterAuthProvider = new firebase.auth.TwitterAuthProvider();
export const githubAuthProvider = new firebase.auth.GithubAuthProvider();